module.exports = __webpack_public_path__ + "img/inspiration-1@2x copy.6b14642.jpg";